import * as actionTypes from './helpHomeActionTypes';

const setPartnerState = (isPotentialPartner: boolean) => ({
  type: actionTypes.SET_PARTNER_STATUS,
  payload: isPotentialPartner,
});

export { setPartnerState };
